<script lang="ts">
import Button from '@/components/core/Button.svelte'
import Drawer from '@/components/drawer/Drawer.svelte'
import DrawerActions from '@/components/drawer/DrawerActions.svelte'
import DrawerContent from '@/components/drawer/DrawerContent.svelte'
import DrawerContentText from '@/components/drawer/DrawerContentText.svelte'
import DrawerHeader from '@/components/drawer/DrawerHeader.svelte'
import { testIds } from '@/constants'
import { closeChatByVisitor } from '@/modules/chat'
import { closeDrawer } from '@/modules/drawers'
import { t } from '@/modules/translations'

const { closeChatDrawer, closeChatConfirmButton, closeChatDeclineButton } = testIds
</script>

<Drawer onClose={closeDrawer} testId={closeChatDrawer}>
	<DrawerHeader title={$t('closeConversationModal.title')} />
	<DrawerContent>
		<DrawerContentText>
			{$t('closeConversationModal.text')}
		</DrawerContentText>
	</DrawerContent>
	<DrawerActions>
		<div class="mb-3">
			<Button isBlock onClick={closeChatByVisitor} testId={closeChatConfirmButton}
				>{$t('closeConversationModal.button')}</Button
			>
		</div>
		<Button variant="outline" isBlock onClick={closeDrawer} testId={closeChatDeclineButton}>{$t('general.back')}</Button
		>
	</DrawerActions>
</Drawer>
